/**
 * The function will extract from the given time only the seconds and will format it to SS.
 * @param time in seconds
 */
export var _getSeconds = function _getSeconds(time) {
  var s = Math.floor(time % 60);
  return s < 10 ? "0" + s : "" + s;
};
/**
 * The function will extract from the given time only the minutes and will format according the following rules:
 * 1) 0 - In case there are no hours and minutes
 * 2) 0M - In case  (0 < minutes < 10) || (minutes === 0 && hours > 0)
 * 3) MM - Minutes >= 10
 * @param time in seconds
 */

export var _getMinutes = function _getMinutes(time) {
  var h = Math.floor(time / 3600);
  var m = Math.floor(time / 60 % 60);
  var needsZeroAppending = m < 10 && m > 0 || m === 0 && h > 0; // section 2 in the comment above.

  return needsZeroAppending ? "0" + m : "" + m;
};
/**
 * returns only the hours from the given time.
 * @param time in seconds
 */

export var _getHours = function _getHours(time) {
  return Math.floor(time / 3600);
};
/**
 * The function will format the time according the following rules:
 * 1) Less than 1 minute: {0:ss}.
 * 2) More than 1 minute & Less than 1 hour: {mm:ss}.
 * 3) More than 59 minutes: {h:mm:ss}
 * @param time in seconds
 */

export var formatTime = function formatTime(time) {
  var result = _getMinutes(time) + ":" + _getSeconds(time);

  var hours = _getHours(time);

  return hours > 0 ? hours + ":" + result : result;
};